// Arabische teksten van de to-do's in de ouderapp (zie todoApp.nl.ts); de app zet ze in RTL.
export const appTodoAr = {
    tab: 'مهام لاحقة',
    repeatOption: 'بدون تاريخ (مهمة لاحقة)',
    repeatHint: 'بدون تاريخ أو وقت. تبقى المهمة حتى تُنجز.',
    description: 'شرح (اختياري)',
    dueDate: 'قبل تاريخ (اختياري)',
    dueClear: 'بدون تاريخ نهاية',
    from: 'من {name}',
    due: 'قبل {date}',
    emptyTitle: 'لا توجد مهام لاحقة',
    emptyBody: 'المهمة اللاحقة بلا تاريخ أو وقت وتبقى حتى تُنجز. مثلًا: طلاء خزانة الأحذية.',
    add: 'إضافة مهمة لاحقة',
    doneSection: 'تم',
    doneOn: 'أُنجزت في {date}',
    newTitle: 'مهمة لاحقة جديدة',
    editTitle: 'تعديل المهمة اللاحقة',
    important: 'مهم',
    importantHint: 'تظهر في الأعلى مع علامة صغيرة.',
    assign: 'إسناد إلى',
    assignHint: 'لا تُسند المهام إلى الرضّع والأطفال الصغار.',
    assigned: 'أُسندت إلى {names}',
    // Oprichter 6 okt: privé to-do's in Mijn omgeving en de kaart op Vandaag.
    privateNote: 'أنت وحدك ترى هذه المهام اللاحقة. لا تراها العائلة ولا اللوحة. لا يظهر شيء على اللوحة إلا إذا أكّدت ذلك بنفسك صراحةً لجهاز لوحي معيّن، ويمكنك إزالته في أي وقت.',
    privateEntry: 'مهمة لاحقة خاصة؟ أنشئها في مساحتي. هناك تراها أنت وحدك.',
    privateEntryButton: 'إلى مساحتي',
    gateTitle: 'مهامك اللاحقة الخاصة',
    gateBody: 'مهامك اللاحقة الخاصة موجودة في مساحتي. أنت وحدك تراها: لا تراها العائلة ولا اللوحة. لا يظهر شيء على اللوحة إلا إذا أكّدت ذلك بنفسك صراحةً لجهاز لوحي معيّن، ويمكنك إزالته في أي وقت.',
    gateOpen: 'افتح مساحتي',
    gateOpening: 'جارٍ الفتح…',
    widgetEmpty: 'لا توجد مهام لاحقة مفتوحة.',
    widgetAll: 'كل المهام اللاحقة',
    widgetMore: '+{count} أخرى',
    widgetFrom: 'من {name}، للقراءة فقط',
    widgetOpenIn: 'افتح في {name}',
    widgetPending: 'بانتظار الموافقة',
};
//# sourceMappingURL=todoApp.ar.js.map